<template>
  <div>
    <p>
      The following tables contain a structured copy of the field description.
      Note that the values are all given in SI as this is the unit system used
      in the API. It should be read as follows :
    </p>
    <ul>
      <li>
        <p>
          <b>First table</b> : this table gives an exaustive list of the fields
          that are required (resp. optional) for the construction of a valid
          object. If several types of the object exist, all possible types will
          be listed along with their respective additional properties.
        </p>
      </li>
      <li>
        <p>
          <b>Second Table</b> : this table gives the properties of the fields
          previously listed as required or optional for the creationg of a valid
          object. A column 'Implications' lists all additional contrainsts which
          can be imposed based on the value given to a particular field
        </p>
      </li>
      <li>
        <p>
          <b>Additional, type-specific tables</b> : if the object can be of
          various types, specific tables will show the properties of the fields
          which are required (resp. optional) for each particular type.
        </p>
      </li>
      <li>
        <p>
          <b>Remaining field properties</b> : if values contained in an
          enumerated field or contained in the 'Implication' column need
          descriptions, their properties will be presented in this last table
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'tooltipSunZenithAngle'
}
</script>
